module.exports = __webpack_public_path__ + "images/jd_vehicle.aa3db3b82439664f977bc6943557b6c6.png";